/**
 * TRAC-1212 — who started a live-person handoff. Recorded on handoff_requested (here, in
 * the browser) and on the server's handoff_accepted / handoff_declined.
 *
 *   shopper_button    the shopper pressed a live-chat button or door: the mode banner, the
 *                     "which team?" doors, the human-first welcome doors, the outage
 *                     overlay's "Talk to a Tire Expert"
 *   shopper_asked_ai  the shopper asked the AI for a person in words and it connected them
 *   ai_offered        the AI suggested a person the shopper had not asked for, and the
 *                     shopper accepted (the soft-handoff card's Connect, or its countdown)
 *   staff_sent        a staff member pressed "Send to a rep" on the live chat monitor
 *                     (TRACI-628) and this widget picked it up
 *
 * Measurement only: nothing here may change what the handoff does.
 */
export type HandoffInitiator = 'shopper_button' | 'shopper_asked_ai' | 'ai_offered' | 'staff_sent';

const INITIATORS: ReadonlySet<string> = new Set(['shopper_button', 'shopper_asked_ai', 'ai_offered', 'staff_sent']);

export function isHandoffInitiator(v: unknown): v is HandoffInitiator {
  return typeof v === 'string' && INITIATORS.has(v);
}

/**
 * Who started an agent-triggered handoff, from its `human_handoff` control event. The agent
 * says so itself (`initiatedBy`); an older agent that does not is read from the escalation
 * it chose: "immediate" is only ever an explicit person-ask, anything else was its offer.
 */
export function initiatorFromHandoffEvent(chunk: { initiatedBy?: unknown; escalation?: unknown }): HandoffInitiator {
  if (isHandoffInitiator(chunk.initiatedBy) && chunk.initiatedBy !== 'shopper_button') return chunk.initiatedBy;
  return chunk.escalation === 'immediate' ? 'shopper_asked_ai' : 'ai_offered';
}
